import { BASE_URL } from '@utils/constants.js';
import { logoutClearStore } from '@utils/functions.js';
import httpClient from '@utils/httpClient.js';
import Cookies from 'js-cookie';
import { call, put, takeLatest } from 'redux-saga/effects';

import { userSettingsError, userSettingsRequest, userSettingsStore } from './userSettingsActions.js';

function getUserSettingsApiCall() {
  return httpClient.get(`api/settings`);
}

function logoutApiCall() {
  return httpClient.post(`api/account/logout`);
}

function* getUserSettingsSaga() {
  try {
    const { data: userSettings } = yield call(getUserSettingsApiCall);

    yield put(userSettingsStore(userSettings));

    Cookies.set('unilinkUserId', userSettings['userId'], { path: '/' });
  } catch (error) {
    if (error?.response?.status === 401) {
      yield call(logoutApiCall);
      logoutClearStore();
      window.open(BASE_URL, '_self');
    }
    // console.log('getUserSettingsSaga error', error.toString());
    // console.log('getUserSettingsSaga error', error);
    yield put(userSettingsError(error.Message ? error.Message : error.toString()));
  }
}

export function* getUserSettingsWatcher() {
  yield takeLatest(userSettingsRequest.type, getUserSettingsSaga);
}
